import { pathOr } from 'ramda';
import { IRealtyValuation, ISoldData } from '../../types/realtyValuation';

export const getSoldData = (realtyValuation: IRealtyValuation): ISoldData | null => {
  return pathOr(null, ['salesDynamics', 'soldPercentData'], realtyValuation);
};
